<tui-root [attr.tuiTheme]="null">
  <div class="layout-container" style="width: 100vw; height: 100vh">
    <eai-chat-box></eai-chat-box>
  </div>
</tui-root>
